import React, { useState, useEffect } from 'react';

const AppreciationEditModal = ({ testimonial, isOpen, onClose, onSave, availableImages, onUpload }) => {
    const [formData, setFormData] = useState({
        text: '',
        author: '',
        imageUrl: ''
    });
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        if (testimonial) {
            setFormData({
                text: testimonial.text || '',
                author: testimonial.author || '',
                imageUrl: testimonial.imageUrl || ''
            });
        } else {
            setFormData({
                text: '',
                author: '',
                imageUrl: ''
            });
        }
    }, [testimonial]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        setIsUploading(true);
        try {
            const uploadedPaths = await onUpload(files);
            if (uploadedPaths && uploadedPaths.length > 0) {
                setFormData(prev => ({ ...prev, imageUrl: uploadedPaths[0] }));
            }
        } catch (error) {
            console.error("Upload failed in modal:", error);
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl my-8">
                <h2 className="text-2xl font-bold mb-4">{testimonial ? 'Edit Testimonial' : 'Add New Testimonial'}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Author Name</label>
                        <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                            value={formData.author}
                            onChange={(e) => setFormData({ ...formData, author: e.target.value })}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Testimonial Text
                            <span className="text-xs text-gray-500 ml-2">(HTML allowed: use &lt;br&gt;&lt;/br&gt; for line breaks)</span>
                        </label>
                        <textarea
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black font-mono text-sm"
                            value={formData.text}
                            onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                            rows={12}
                            required
                            placeholder="Enter testimonial text here. Use <br></br> for line breaks."
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Image</label>
                        <div className="flex gap-2 mb-2">
                            <select
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                value={formData.imageUrl}
                                onChange={(e) => setFormData({ ...formData, imageUrl: e.target.value })}
                                required
                            >
                                <option value="">Select an image</option>
                                {availableImages.map((img) => (
                                    <option key={img} value={img}>
                                        {img}
                                    </option>
                                ))}
                            </select>
                            <label className={`px-4 py-2 bg-gray-200 text-gray-700 rounded-md cursor-pointer hover:bg-gray-300 transition-colors ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    disabled={isUploading}
                                    className="hidden"
                                />
                                {isUploading ? '...' : 'Upload'}
                            </label>
                        </div>

                        {formData.imageUrl && (
                            <div className="mt-2">
                                <p className="text-xs text-gray-500 mb-1">Preview:</p>
                                <img
                                    src={`https://storage.googleapis.com/wacofirefightersbenefit/${formData.imageUrl}`}
                                    alt="Preview"
                                    className="h-40 object-contain rounded border border-gray-200"
                                />
                            </div>
                        )}
                    </div>
                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition-colors"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AppreciationEditModal;
